import { configureStore } from '@reduxjs/toolkit';
import sodpReducer from './sodpSlice';

export const store = configureStore({
  reducer: {
    sodp: sodpReducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: ['persist/PERSIST'],
      },
    }),
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
